window.addEventListener('DOMContentLoaded', function() {

  //split_mainnav_items();
  //add_footernav_4me();
  add_discount_badges();
});

function split_mainnav_items(){
  let dis = document.querySelectorAll('.header__inline-menu > ul.list-menu > li:nth-child(-n + 4) ul.header__submenu li a');

  for (let i = 0; i < dis.length; i++) {
    let repl = ''
    let s1 = dis[i].innerHTML;
    let s2 = s1.split(/\n/)[1]; 
    let s3 = s2.trim().split(' ');
   
    if(s3.length>1){
      let s3_last = s3.pop();
      repl += '<span>' + s3.join(' ') + '</span>';
      repl += s3_last;
    }
    else{
      repl = '<span>' + s3[0] + '</span>';
    }

    dis[i].innerHTML = s1.replace(s2, repl);
  }
}

function add_footernav_4me(){
  let e4mes = document.querySelectorAll('footer .footer__content-top .footer-block--menu .footer-block__details-content li a');
  for (let i = 0; i < e4mes.length; i++) {
    e4mes[i].innerHTML = e4mes[i].innerHTML.trim().replace(/4me/g, '<span class="e4me">4me</span>');
  }
}

function add_discount_badges(){
  let badges = document.querySelectorAll('.product-grid .grid__item .card-information .price[data-badge]:not([data-badge=""])');
  for (let i = 0; i < badges.length; i++) {
    const bt = badges[i].getAttribute('data-badge');
  
    const container = badges[i].closest('.card');

    if (container) {
      const bp = container.querySelector('.card__inner .card__badge');
      if (bp) {
        bp.innerHTML = '<span class="badge" data-badge-txt="' + bt + '">' + bt + '</span>'; 
      }
    }
  }
}